// extracted by mini-css-extract-plugin
export var collapse = "Collapse-module--collapse--ce31d";